export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_OCCUPANCY":
      return [...state, action.payload.occupancy];
    case "UPDATE_OCCUPANCIES":
      return action.payload.occupancies || [];
    case "DELETE_OCCUPANCY":
      return state.filter((occupancy) => {
        return occupancy.id !== action.payload.occupancy.id
      });
    default:
      return state;
  }
}
